import React, { Component } from 'react';
import { Table, Modal, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class UpdateLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { investigationId, jdeApplyId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryJdeApplyChangeRecord,
            data: {
                investigationId,
                jdeApplyId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.jdeApplyChangeRecords,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '更新时间',
            dataIndex: 'createTime',
            width: 100,
        }, {
            title: '更新人',
            dataIndex: 'userCompellation',
            width: 100,
            render: (text, record) => {
                const { employeeCode } = record;
                return `${text}${employeeCode ? `(${employeeCode})` : ''}`;
            }
        }, {
            title: '更新字段',
            dataIndex: 'fieldName',
            width: 110,
        }, {
            title: '更新前',
            dataIndex: 'originalValue',
            width: 120,
        },  {
            title: '更新后',
            dataIndex: 'changeValue',
            width: 120,
        }
    ])

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item } ));
        return dataSource;
    }

    render() {
        const { visible, loading, record: { jdeApplyCode } } = this.state;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={800}
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        申请编号：{jdeApplyCode}
                    </div>
                    <div style={{ marginTop: -1, borderBottom: '1px solid #e9e9e9' }}>
                        <Table
                            bordered
                            loading={loading}
                            pagination={false}
                            scroll={{x: 540, y: 400}}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.jdeApplyApprovalHistoryId}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}
export default UpdateLog


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/UpdateLog.js